(function () {
  "use strict";

  // ── config ────────────────────────────────────────────────
  var BACKEND = "https://teal-camel-256853.hostingersite.com";

  // ── query params ──────────────────────────────────────────
  var params = new URLSearchParams(window.location.search);
  var ref    = params.get("ref");
  var token  = params.get("token");

  // ── state elements ────────────────────────────────────────
  var $loading = document.querySelector('[data-ap-state="loading"]');
  var $error   = document.querySelector('[data-ap-state="error"]');
  var $form    = document.querySelector('[data-ap-state="form"]');
  var $success = document.querySelector('[data-ap-state="success"]');

  function show(state) {
    [$loading, $error, $form, $success].forEach(function (el) { el.hidden = true; });
    if (state === "loading") $loading.hidden = false;
    if (state === "error")   $error.hidden   = false;
    if (state === "form")    $form.hidden    = false;
    if (state === "success") $success.hidden = false;
  }

  function showError(msg) {
    var el = document.querySelector("[data-ap-error-msg]");
    if (el) el.textContent = msg;
    show("error");
  }

  function formatMoney(minor, currency) {
    var amount = Number(minor) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: (currency || "eur").toUpperCase(),
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2) + " " + String(currency || "").toUpperCase();
    }
  }

  // ── NEW: apartment name rendering ─────────────────────────
  function buildApartmentLabel(productName, productVariant) {
    if (!productName) return "";
    if (productVariant && productVariant !== "Default Title") {
      return productName + " — " + productVariant;
    }
    return productName;
  }

  function setApartment(data) {
    var label = buildApartmentLabel(data.productName, data.productVariant);
    if (!label) return;

    // Form state badge
    var badge = document.querySelector("[data-ap-apartment]");
    if (badge) {
      badge.textContent = label;
      badge.hidden = false;
    }

    // Success state row
    var successRow = document.querySelector("[data-ap-apartment-success-row]");
    var successVal = document.querySelector("[data-ap-apartment-success]");
    if (successRow && successVal) {
      successVal.textContent = label;
      successRow.hidden = false;
    }
  }

  // ── boot ──────────────────────────────────────────────────
  if (!ref || !token) {
    showError(
      "This link is missing required parameters. Please use the link from your confirmation email."
    );
    return;
  }

  show("loading");

  fetch(
    BACKEND +
      "/api/approve-plan?ref=" + encodeURIComponent(ref) +
      "&token=" + encodeURIComponent(token)
  )
    .then(function (r) {
      return r.json().then(function (d) {
        return { status: r.status, data: d };
      });
    })
    .then(function (res) {
      var d = res.data || {};

      if (d.ok === true) {
        renderForm(d);
        return;
      }

      if (res.status === 409) {
        showError(
          "This plan has already been activated. If that's unexpected, contact us at hello@roamcollective.com."
        );
        return;
      }
      if (res.status === 404) {
        showError(
          "We couldn't find that booking. Please use the link from your confirmation email, or contact hello@roamcollective.com."
        );
        return;
      }
      if (res.status === 401) {
        showError(
          "This link has expired or is invalid. Please use the most recent link from your email."
        );
        return;
      }
      showError(d.error || "We couldn't load your plan. Please try again.");
    })
    .catch(function () {
      showError(
        "We couldn't reach the server. Please check your connection and try again."
      );
    });

  // ── render form + Stripe ──────────────────────────────────
  function renderForm(data) {
    setText("[data-ap-ref]",               data.bookingRef);
    setText("[data-ap-ref-success]",       data.bookingRef);
    setText("[data-ap-deposit]",           formatMoney(data.depositAmount, data.currency));
    setText("[data-ap-first]",             formatMoney(data.installmentFirst, data.currency));
    setText("[data-ap-base]",              formatMoney(data.installmentBase, data.currency));
    setText("[data-ap-count]",             data.installmentCount);
    setText("[data-ap-count-minus-one]",   data.installmentCount - 1);
    setText("[data-ap-remaining]",         formatMoney(data.remainingAmount, data.currency));

    // NEW: fill the apartment name from the API
    setApartment(data);

    show("form");

    if (!window.Stripe) {
      showError("Stripe failed to load. Please refresh the page.");
      return;
    }
    if (!data.stripePublishableKey || !data.setupIntentClientSecret) {
      showError("Payment setup is incomplete. Please contact hello@roamcollective.com.");
      return;
    }

    var stripe = window.Stripe(data.stripePublishableKey);
    var elements = stripe.elements();

    var cardEl = elements.create("card", {
      style: {
        base: {
          fontFamily: "inherit",
          fontSize: "16px",
          color: "#281E1E",
          "::placeholder": { color: "#8A8578" },
        },
        invalid: { color: "#E85D3E", iconColor: "#E85D3E" },
      },
    });
    cardEl.mount("#ap-card-element");

    var $formInner   = document.getElementById("ap-form");
    var $submit      = document.querySelector("[data-ap-submit]");
    var $submitLabel = document.querySelector("[data-ap-submit-label]");
    var $formError   = document.querySelector("[data-ap-form-error]");

    cardEl.on("change", function (event) {
      if (event.error) {
        $formError.textContent = event.error.message;
        $formError.hidden = false;
      } else {
        $formError.hidden = true;
      }
    });

    $formInner.addEventListener("submit", function (e) {
      e.preventDefault();
      $formError.hidden = true;
      $submit.disabled = true;
      $submitLabel.textContent = "Saving…";

      stripe
        .confirmCardSetup(data.setupIntentClientSecret, {
          payment_method: { card: cardEl },
        })
        .then(function (result) {
          if (result.error) {
            $formError.textContent =
              result.error.message || "Your card could not be saved. Please try again.";
            $formError.hidden = false;
            $submit.disabled = false;
            $submitLabel.textContent = "Save card & activate plan";
            return;
          }
          show("success");
        })
        .catch(function () {
          $formError.textContent =
            "Something went wrong saving your card. Please try again.";
          $formError.hidden = false;
          $submit.disabled = false;
          $submitLabel.textContent = "Save card & activate plan";
        });
    });
  }

  function setText(sel, val) {
    var el = document.querySelector(sel);
    if (el) el.textContent = val == null ? "" : String(val);
  }
})();
